module.exports = __webpack_public_path__ + "media/images/huda_02-bc0e879ffbf8a8e01645550e04326e39.jpg";